import Webinar from "components/webinar"

export const ROUTES = [
	{
		pathname: "/:page",
		exact: true,
		Component: Webinar,
	},
]